<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.00039 8C10.2095 8 12.0004 6.20914 12.0004 4C12.0004 1.79086 10.2095 0 8.00039 0C5.79125 0 4.00039 1.79086 4.00039 4C4.00039 6.20914 5.79125 8 8.00039 8ZM6.39961 9.60013C3.74864 9.60013 1.59961 11.7492 1.59961 14.4001C1.59961 15.2838 2.31595 16.0001 3.19961 16.0001H12.7996C13.6833 16.0001 14.3996 15.2838 14.3996 14.4001C14.3996 11.7492 12.2506 9.60013 9.59961 9.60013H6.39961Z"
    />
  </svg>
</template>
